import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Checkbox from '../../../../components/checkbox'
import { FormattedMessage } from 'react-intl'

export default props => {
    useStyles(classes)
    const { selected, onSelect, onAddWish, onDelete } = props

    return <div className={classes.Container}>
        <div>
            <Checkbox selected={selected} onClick={ e => onSelect(!selected) }/>
            <span className={classes.All}>
                <FormattedMessage id="all" defaultMessage="All"/>
            </span>
        </div>
        <div className={classes.Buttons}>
            <span className={classes.Button} onClick={onAddWish}>
                <FormattedMessage id="move_to_wishlist" defaultMessage="Move To Wishlist"/>
            </span>
            <span className={classes.Button} onClick={onDelete}>
                <FormattedMessage id="delete" defaultMessage="Delete"/>
            </span>
        </div>
    </div>
}